export default "__VITE_ASSET__O7IbHhxY__"